import { memo, type ComponentType } from 'react';
import { styled } from '@mui/material/styles';
import MuiTooltip, { type TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

type TooltipStyledProps = {
  tooltipstyles?: React.CSSProperties;
} & TooltipProps;

export const Tooltip: ComponentType<TooltipStyledProps> = memo(
  styled(({ className, ...props }: TooltipStyledProps) => (
    <MuiTooltip
      {...props}
      arrow={true}
      classes={{ popper: className }} />
  ), { shouldForwardProp: prop => prop !== 'tooltipStyles' })<TooltipStyledProps>(({ theme, tooltipstyles }) => ({

    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.black.light1,
      color: theme.palette.secondary.main,
      fontSize: 13,
      fontFamily: theme.fonts.semiBold,
      ...tooltipstyles,
    },

    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.black.light1,
    },
  })));

export const PopperTooltip: React.ComponentType<TooltipProps> = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: 'var(--box-shadow)',
  },
}));